import { type NodeProps, NodeResizer } from '@xyflow/react';

type FlowData = { label: string; color?: string; isEditMode?: boolean };

export function GroupFlowNode({ data, selected }: NodeProps) {
  const d = data as FlowData;
  const bg = d.color ?? '#f1f5f9';
  return (
    <div
      className={`h-full w-full rounded-xl border-2 p-3 shadow-md ${
        selected ? 'ring-2 ring-sky-500' : 'border-slate-200'
      }`}
      style={{ backgroundColor: bg }}
    >
      {d.isEditMode ? (
        <NodeResizer
          color="#2563eb"
          isVisible
          minWidth={200}
          minHeight={120}
          maxWidth={2000}
          maxHeight={2000}
        />
      ) : null}
      <div className="text-left text-base font-bold uppercase tracking-wide text-slate-900">
        {d.label}
      </div>
    </div>
  );
}
